var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4",attrs:{"flat":"","id":"uploadCenter"}},[_c('v-container',[_c('WidgetDevice',{ref:"wd",attrs:{"adminView":true,"startDevice":_vm.device,"startCompanyGuid":_vm.companyId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }